export type StorePlatform = 'ios' | 'android';

// Same pages as the L8 email (backend/services/interventionRequestNotification.service.ts STORE_URL_DEFAULTS).
export const STORE_LINKS: Record<StorePlatform, string> = {
  // Plain until the App Store provider token is known (needed for `pt`/`ct` campaign tags).
  ios: 'https://apps.apple.com/app/id6760658206',
  android: 'https://play.google.com/store/apps/details?id=com.globegroupe.globeperfectstore&referrer=utm_source%3Dweb-banner%26utm_campaign%3Dapp-adoption',
};
